import { render } from "./Todo.vue?vue&type=template&id=2d458538&scoped=true"
import script from "./Todo.vue?vue&type=script&lang=ts"
export * from "./Todo.vue?vue&type=script&lang=ts"

import "./Todo.vue?vue&type=style&index=0&id=2d458538&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2d458538"

export default script